import { createContext, use, useLayoutEffect } from 'react';

export const TileLinkStateContext = createContext<
  ((value: unknown) => void) | null
>(null);

/** Lets a tile body publish extra router state through the shell's `tile.link` navigation. */
export function useTileLinkState(linkState: unknown) {
  const setLinkState = use(TileLinkStateContext);

  useLayoutEffect(() => {
    if (!setLinkState) {
      return undefined;
    }
    setLinkState(linkState);
    return () => setLinkState(undefined);
  }, [setLinkState, linkState]);
}
